import React from "react";

import { LandingPage } from "../../components/LandingPage";

const Landing: React.FC = () => <LandingPage />;

export default Landing;
